export default __webpack_public_path__ + "static/media/chili_peppers.c6101c89.png";